const hydratePathname = (pathname: string, parameters: Record<string, any> = {}) => {
  const paramsReducer = (acc: string, key: string) => acc.split(`:${key}`).join(parameters[key])

  return Object.keys(parameters).sort().reverse().reduce(paramsReducer, pathname)
}

export { hydratePathname }
